module.exports = __webpack_public_path__ + "img/qrcode1.d3a4a382.png";